import { enUS, ptBR, srRS, ukUA } from '@mui/material/locale';
import { useTranslation } from 'react-i18next';

import enFlag from '../assets/flags/en.svg';
import brFlag from '../assets/flags/br.svg';
import srFlag from '../assets/flags/sr.svg';
import ukFlag from '../assets/flags/uk.svg';
import { SystemLang } from '../types/app';

const enValue = 'en-US';

export const DEFAULT_LANG_VALUE = enValue;

export default function useGetSystemLangs() {
  const { t } = useTranslation();
  const LANGS: SystemLang[] = [
    {
      label: t('lang.English'),
      value: enValue,
      systemValue: enUS,
      icon: enFlag,
      iso2: 'GB',
    },
    {
      label: t('lang.Serbian'),
      value: 'sr-Latn-RS',
      systemValue: srRS,
      icon: srFlag,
      iso2: 'RS',
    },
    {
      label: t('lang.Portuguese'),
      value: 'pt-BR',
      systemValue: ptBR,
      icon: brFlag,
      iso2: 'BR',
    },
    {
      label: t('lang.Ukrainian'),
      value: 'uk-UA',
      systemValue: ukUA,
      icon: ukFlag,
      iso2: 'UA',
    },
  ];

  const DEFAULT_LANG_OBJECT = LANGS[0];

  return { LANGS, DEFAULT_LANG_OBJECT };
}
